/**
 * <TimelineForm />
 *
 * @parent anybody
 * @children 
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import Form from 'components/Form';
import locale from './locale';

import './TimelineForm.scss';

class TimelineForm extends React.Component {

  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
    this.save = this.save.bind(this);

    this.state = {
      formData: props.formData || {},
    }
  }

  componentWillMount() {

  }

  onChange(formData) {
    this.setState({
      formData: {
        ...this.state.formData,
        ...formData,
      }  
    });
  }

  save() {
    const result = this.validate();
    
    if (result.ok) {
      this.submit();
    }
  }

  submit() {
    let toSubmit = {
      ...this.state.formData,
    }


    if (Array.isArray(toSubmit.assigned_to) && toSubmit.assigned_to.length > 0) { 
      toSubmit.assigned_to = toSubmit.assigned_to[0].id; 
    }

    this.props.onSubmit(toSubmit);
  }

  render() {
    const {
      formData,
    } = this.state;
  
    const {
      loading,
      title,
    } = this.props;

    const schema = [
      {
        name: 'title',
        label: __('Title', locale),
        type: 'text',
        required: true,
      },
      {
        label: __('Due', locale),
        name: 'due_datetime',
        type: 'dateTime',
        required: true,
      },
      {
        label: __('Remind At', locale),
        name: 'remind_at',
        type: 'dateTime',
      },
      {
        label: __('Assign To', locale),
        name: 'assigned_to',
        type: 'selectTeacher',
      },
      {
        label: __('Note', locale),
        name: 'note',
        type: 'textarea',
      },
      {
        name: 'remind_both',
        type: 'checkbox',
        placeholder: __(`Also remind parents and students (If don't check, will only remind teacher)`, locale),
        inputTransform: (data)=>{
          return data === 1;
        },
        outputTransform: (data)=>{
          return data ? 1 : 0;
        }
      },
    ];

    return (
      <div className='TimelineForm'>
        <Form
          title={title}
          loading={loading}
          onChange={this.onChange} 
          schema={schema} 
          formData={formData}
          formStyle='inline'
          getValidationRef={(fn)=>{
            this.validate = fn; 
          }} 
        />
        { loading !== true && 
          <section className='btnSection'>
            <a className='btn btn-primary' onClick={this.save}>{__('Save', locale)}</a>
            <a className='btn btn-default' onClick={this.props.triggerCancel}>{__('Cancel', locale)}</a>
          </section>
        }
      </div>
    )
  }
}

export default TimelineForm;



// WEBPACK FOOTER //
// ./src/template/Docks/StudentInfo/Timeline/TimelineForm.js